import { render, staticRenderFns } from "./SettingsWeekCompilation.vue?vue&type=template&id=a485d926"
import script from "./SettingsWeekCompilation.vue?vue&type=script&lang=js"
export * from "./SettingsWeekCompilation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a485d926')) {
      api.createRecord('a485d926', component.options)
    } else {
      api.reload('a485d926', component.options)
    }
    module.hot.accept("./SettingsWeekCompilation.vue?vue&type=template&id=a485d926", function () {
      api.rerender('a485d926', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/partials/SettingsWeekCompilation.vue"
export default component.exports